"use client";
import * as React from "react";
const SvgAutoFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 17", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M4.95 2.95 6.85 4 5.8 2.11 6.86.2l-1.9 1.06L3.04.2l1.07 1.9-1.07 1.91zm9.15 7.46-1.9-1.06 1.06 1.9-1.07 1.9 1.9-1.06L16 13.15l-1.07-1.9L16 9.35zM16 .21l-1.9 1.06L12.19.2l1.07 1.9-1.07 1.91 1.9-1.06L16 4l-1.07-1.9zm-5.81 4.02a.76.76 0 0 0-1.08 0l-8.89 8.9a.76.76 0 0 0 0 1.07l1.79 1.78a.76.76 0 0 0 1.07 0l8.88-8.88a.76.76 0 0 0 0-1.08zM9.4 8.42 7.8 6.8l1.86-1.86 1.61 1.62z" }));
export {
  SvgAutoFilled as default
};
